class TrendReports {
	init() {
		this.bindEvents();
		this.createJumpTo();
	}

	bindEvents() {
		//$('#trend-reports .accordion').on('click', e => this.toggleAccordion(e));

		$('.trends-selectpicker').on('change', e => this.jumpToSection(e));
	}

	createJumpTo() {
		$('#trend-reports section > h2').each((index, element) => {
			$('.trends-selectpicker').append(`<option value='${element.id}'>${$(element).text()}</option>`);
		});
	}

	jumpToSection(e) {
		$('html, body').animate({ scrollTop: $(`#${e.currentTarget.value}`).offset().top }, 1000);
	}

	toggleAccordion(e) {
		e.preventDefault();
		e.stopPropagation();

		let target = $(e.currentTarget);
		$(target).toggleClass('active');

		let panel = $(target).next();
		$(panel).slideToggle();
	}
}

export default TrendReports;

$(() => {
    const trendreports = new TrendReports();
    trendreports.init();
});